import Element from '@components/element/Element'
import Link from 'next/link'
import React from 'react'
import ProgressiveImage from 'react-progressive-image'
import styled from 'styled-components'

const StyledBgIcon = styled.img`
  width: 100%;
  position: absolute;
  bottom: -40%;
  left: -20%;
  transform: rotate(20deg);
  opacity: 0.3;
  filter: grayscale(1);
  height: 100%;
`
const StyledCard = styled.div`
  position: relative;
  padding: 3rem;
  margin-bottom: 1rem;
  text-decoration: underline;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  width: ${props => props.width || 'auto'};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  transition: background 0.2s;
  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.colors.grey};
    ${StyledBgIcon} {
      filter: grayscale(1) invert(1);
    }
  }
`

const SingleDynastyCard = ({ dynasty: { name, slug, element }, width }) => {
  return (
    <Link href={`/dynasties/${slug}`}>
      <StyledCard width={width}>
        <ProgressiveImage
          placeholder={element?.icon?.formats?.thumbnail?.url}
          src={element?.icon?.formats?.small?.url}
          style={{ width: '100%' }}
        >
          {(src, loading) => (
            <StyledBgIcon
              alt={element?.name}
              src={src}
              style={{ filter: loading ? 'blur(2px)' : '' }}
            />
          )}
        </ProgressiveImage>
        <Element
          height="100%"
          icon={element?.icon?.formats?.small?.url}
          name={element?.name}
          thumbnail={element?.icon?.formats?.thumbnail?.url}
          width="100%"
        />
        {name}
      </StyledCard>
    </Link>
  )
}

export default SingleDynastyCard
